/*  ========================================================================
    # Components - Lazy Image
    ========================================================================  */

import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import useLocalization from '../hooks/useLocalization';
import bem from '../utils/bem';

const Lightbox = ({ openLightbox, onCloseLightbox, children }) => {
  const [isOpen, setIsOpen] = useState(false);
  const local = useLocalization();

  // Icons
  const iconClose = `${local('svgSprite')}#close`;

  const handleLightboxClose = () => {
    setIsOpen(false);
    onCloseLightbox();
    document.body.style.overflow = null;
  };

  useEffect(() => {
    if (openLightbox) {
      setIsOpen(true);
      document.body.style.overflow = 'hidden';
    }
  }, [openLightbox]);

  return (
    <div className={bem('c-lightbox', '', { open: isOpen })}>
      <button
        type='button'
        title='Close Lightbox'
        className={'c-lightbox__close'}
        onClick={() => handleLightboxClose()}
      >
        <svg viewBox='0 0 200 200'>
          <use href={iconClose} />
        </svg>
      </button>
      <div className={'c-lightbox__wrapper'}>{children}</div>
    </div>
  );
};

Lightbox.propTypes = {
  openLightbox: PropTypes.bool,
  onCloseLightbox: PropTypes.func,
  children: PropTypes.element
};

export default Lightbox;
